/* Filterleiste „Variante 1 – Dropdown-Leiste" (Ben, 2026-09-07) – Theme-Fassung 2026-09-13.
   Optik/Bedienung 1:1 wie der lokale Prototyp; das Filtern/Sortieren/Zählen übernimmt Shopify (Search & Discovery):
   die Leiste ist ein GET-Formular auf die Kollektions-URL, Checkboxen = Filter-Parameter, sort_by = Sortierung. */
(function(){
  var bar=document.getElementById('fbar'); if(!bar) return;
  var $=function(s,r){return (r||document).querySelector(s);}, $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var dirty=false, timer=null;
  function submit(){ clearTimeout(timer); dirty=false; bar.classList.add('fb-busy'); if(bar.requestSubmit) bar.requestSubmit(); else bar.submit(); }
  function queue(){ dirty=true; clearTimeout(timer); timer=setTimeout(submit,650); }
  function closeAll(except){
    $$('.fb-dd',bar).forEach(function(d){ if(d!==except){ $('.fb-panel',d).classList.remove('fb-open'); $('.fb-btn',d).setAttribute('aria-expanded','false'); } });
    if(dirty) submit();
  }
  $$('.fb-dd',bar).forEach(function(d){
    var b=$('.fb-btn',d), p=$('.fb-panel',d);
    b.addEventListener('click',function(){
      var open=p.classList.contains('fb-open'); closeAll(open?null:d);
      p.classList.toggle('fb-open',!open); b.setAttribute('aria-expanded',String(!open));
      if(!open){ var f=$('input,[role=option],button',p); f&&setTimeout(function(){f.focus();},60); }
    });
    $$('input[type=checkbox]',p).forEach(function(i){ i.addEventListener('change',queue); });
    var cl=$('[data-close]',d); if(cl) cl.addEventListener('click',function(){ p.classList.remove('fb-open'); b.setAttribute('aria-expanded','false'); if(dirty) submit(); else b.focus(); });
    var cr=$('[data-clear]',d); if(cr) cr.addEventListener('click',function(){ var any=false; $$('input[type=checkbox]',p).forEach(function(i){ if(i.checked){ i.checked=false; any=true; } }); if(any) submit(); });
    $$('[data-sort]',p).forEach(function(o){
      var go=function(){ var h=$('#fb-sortby',bar); if(h){ h.value=o.getAttribute('data-sort'); h.disabled=(h.value===''); } submit(); };
      o.addEventListener('click',go); o.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); go(); } });
    });
  });
  document.addEventListener('click',function(e){ if(!e.target.closest('.fb-dd')) closeAll(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(); });
  /* Sticky-Offset folgt der Unterkante des Headers */
  var lastTop=null; function offset(){ var h=$('.header'), t=h?Math.max(0,Math.round(h.getBoundingClientRect().bottom)):0; if(t!==lastTop){ lastTop=t; bar.style.top=t+'px'; } }
  offset(); window.addEventListener('resize',offset); window.addEventListener('scroll',offset,{passive:true});
})();
